module.exports = __webpack_public_path__ + "img/mapache.d97cd183.png";